import { render } from "./TopPage.vue?vue&type=template&id=b37e60c0"
import script from "./TopPage.vue?vue&type=script&lang=js"
export * from "./TopPage.vue?vue&type=script&lang=js"

import "./TopPage.vue?vue&type=style&index=0&id=b37e60c0&lang=css"
script.render = render

export default script